<template>
  <!-- 对讲正在通话成员 组件 -->
  <el-dialog title="" :visible.sync="WalkieCallingDialogVisible" width="50%" top="3%" :close-on-click-modal="false">
    <div id="setRecord">
      <div class="addRecord">
        <span class="addRecord-title">{{ currenData.groupName }} </span>
        <span class="calling">{{ i18n.t('voiceCallProgress') }}</span>
        <span class="dot">...</span>
        <i class="sys-close-btn" @click="exitRoom('all')"></i>
      </div>
    </div>
    <div id="person">
      <div class="person-list" ref="chatContent" v-if="currenData.userList.length > 0">
        <!-- 群组成员视图 -->
        <ul>
          <li class="person-list-item" v-for="(item, index) in currenData.userList" :key="index">
            <div class="flex">
              <div class="portrait">
                <!-- {{ item.userName | firstName }} -->
              </div>
              <div>
                <div class="portrait-user">
                  {{ item.userName | ellipsisWalkie }}
                </div>
                <!-- <div>{{ currenData.groupName | ellipsisWalkie }}</div> -->
              </div>
            </div>
            <div class="member-staus" :class="item.acceptCall | classFilter">
              <span style="font-size 18px">{{ item.acceptCall | status }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="footer-btn cancel-one" @click="exitRoom('one')">
        <span style="font-size 18px">
          {{ i18n.t('exitVoiceCall') }}
        </span>
      </div>
      <div class="footer-btn cancel-all" @click="exitRoom('all')">
        <span style="font-size 18px">
          {{ i18n.t('endVoiceCall') }}
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { closeVoiceCall } from '@/common/rtc/index'
import i18n from '@/common/i18n'
export default {
  props: {
    WalkieCallingDialogVisible: {
      type: Boolean,
      default: false,
    },
    currenData: {
      type: Object,
    },
    isEnterRoom: {
      type: Boolean,
    },
  },
  data() {
    return {
      i18n: i18n,
    }
  },
  computed: {},
  methods: {
    // 类型为all时 房间内用户都退出，否则只退出发起端的用户，房间内的用户继续通话
    exitRoom(type) {
      if (type === 'all') {
        // 退出全部房间用户通话
        closeVoiceCall(this.currenData, this.isEnterRoom,type)
      }
      // 全部呼叫无人接听时 全部退出房间
      try {
        closeVoiceCall(this.currenData, this.isEnterRoom, type)
      } catch (error) {
        console.log(error)
      }
      // 关闭弹窗
      this.$emit('closeCallingWind')
      // 清空当前选中的list
      this.$emit('clearCurrenDateList')
      // 刷新列表
      this.$emit('handleCurrent')
    },
  },
  watch: {
    currenData: {
      handler() {},
      deep: true,
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
#setRecord
  .addRecord
    position relative
    line-height 50px
    border-radius 4px
    padding 0 15px
    .addRecord-title
      font-size 20px
    .calling
      font-size 20px
    .dot
      font-family: simsun;
      animation: dot 3s infinite step-start;
    .sys-close-btn
      position absolute
      right 10px
      top 50%
      transform translate(0, -50%)
      display block
#person
  height 413px
  padding-left 110px
  padding-top 37px
  padding-bottom 15px
  .person-list
    height 390px
    overflow auto
    .person-list-item
      cursor auto
      position relative
      border-radius: 4px
      margin 5px
      width 22%
      padding 30px 20px
      display inline-block
      .member-staus
        padding 7px
        position absolute
        top 0px
        right 0px
        span
          font-size 18px !important
      .portrait
        width: 40px
        height: 40px
        margin 0 10px
        border-radius: 8px
        font-size: 20px
        text-align center
        line-height 40px
        bg-image-full('~@/icon/voice/person.png')
      .portrait-user
        white-space: nowrap
        line-height: 40px
        font-size 18px !important
.footer
  display flex
  justify-content: center
  padding 21px 0
  .footer-btn
    span
      line-height 36px
      text-align center
      display block
      width: 160px
      height: 36px
      font-size 18px !important
  .cancel-one
    cursor pointer
    margin-right: 80px
    border-radius: 18px
  .cancel-all
    cursor pointer
    border-radius: 18px
@keyframes dot
  0%
    width 0
    margin-right 1.5em
  33%
    width .5em
    margin-right: 1em
  66%
    width: 1em
    margin-right: .5em
  100%
    width: 1.5em
    margin-right: 0

:root .dot
  display: inline-block
  width: 1.5em
  vertical-align: bottom
  overflow: hidden
</style>
